import { clearBranchCache } from '@/utils/branch';

export function authUser(){
  const user = localStorage.getItem('auth_user');
  return user ? JSON.parse(user) : null;
}

export function authToken(){
  return localStorage.getItem('auth_token');
}

export function logoutUser(){
  localStorage.removeItem('auth_user');
  localStorage.removeItem('auth_token');
  localStorage.removeItem('country');
  localStorage.removeItem('currencies');
  localStorage.removeItem('currency');
  localStorage.removeItem('leadMeta');
  localStorage.removeItem('states');
  sessionStorage.removeItem('sidebarScrollTop');
  resetUserPermissionCache();
  clearBranchCache();
}

export function isAuthenticated(){
  return !!localStorage.getItem('auth_token'); 
}

export function clientAdmin(){
  const client_admin = localStorage.getItem('client_admin');
  return client_admin ? JSON.parse(client_admin) : null;
}

export function clientSetting(){
  const client_setting = localStorage.getItem('client_setting');
  return client_setting ? JSON.parse(client_setting) : null;
}

export function resetUserPermissionCache(){
  if (typeof window !== 'undefined') {
    window.__userPermissionLoaded = false;
    window.__lastFetchTime = null;
  }
}